import { render } from "./AdicionarCartaoProfissional.vue?vue&type=template&id=17c0481e&scoped=true"
import script from "./AdicionarCartaoProfissional.vue?vue&type=script&lang=js"
export * from "./AdicionarCartaoProfissional.vue?vue&type=script&lang=js"

import "./AdicionarCartaoProfissional.vue?vue&type=style&index=0&id=17c0481e&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c0481e"]])

export default __exports__